import React from 'react'
import { TheGreatProviderContextT } from '@/types/TheGreatProvider.types'
import { initialIncomingDateTime } from '@/utils/dates.utils'

export const initialIncomingQueries = {
  dateTime: initialIncomingDateTime,
  promoCodes: [],
  search: '',
  filter: '',
  paymentIntentClientSecret: '',
  cartId: '',
  iid: '',
  skip: false,
  admissionType: '',
}

/**
 * Initial context for TheGreatProvider
 */
export const initialGreatProviderContext: TheGreatProviderContextT = {
  handleResetIncomingDateTime: () => { /* empty */ },
  handleSetIncomingPromoCodes: () => { /* empty */ },
  scrollToMainContent: () => { /* empty */ },
  incomingQueries: initialIncomingQueries,
  isEvents: false,
}

export default React.createContext<TheGreatProviderContextT>(initialGreatProviderContext)
